(function() {
  let kustomerInitialized = false;
  let scrollListenerActive = false;
  let scrollHandler = null;

  function initKustomer() {
    Kustomer.start({
      brandId: '688cea10966e5d9cd58ee580'
    });
  }

  function loadKustomerWidget() {
    console.log('Loading Kustomer chat widget for DTC mode');

    if (!kustomerInitialized) {
      var script = document.createElement("script");
      script.id = "Kustomer-js-sdk";
      script.async = true;
      script.src = "https://cdn.kustomerapp.com/chat-web/widget.js";
      script.setAttribute('data-kustomer-api-key', 'eyJhbGciOiJub25lIn0.eyJvcmciOiI2ODhjZWEwNzBkZTAwMGYzNWZmMDBlM2MiLCJvcmdOYW1lIjoiYnJhbmNoIiwicG9kIjoicHJvZDEiLCJyb2xlcyI6WyJvcmcudHJhY2tpbmciXX0.');
      script.onload = initKustomer;
      document.body.appendChild(script);
      kustomerInitialized = true;
    }
  }

  function hideKustomerChat() {
    console.log('Hiding Kustomer chat for B2B mode');

    // Remove scroll listener if active
    if (scrollListenerActive && scrollHandler) {
      window.removeEventListener('scroll', scrollHandler);
      scrollListenerActive = false;
    }

    // Hide Kustomer widget if loaded
    if (window.Kustomer && kustomerInitialized) {
      // Kustomer doesn't have a remove method, so we hide the iframe
      var kustomerIframe = document.querySelector('iframe[title*="Kustomer"]');
      if (kustomerIframe) {
        kustomerIframe.style.display = 'none';
      }
      // Also hide the button
      var kustomerButton = document.querySelector('[data-kustomer-widget-button]');
      if (kustomerButton) {
        kustomerButton.style.display = 'none';
      }
    }
  }

  function showKustomerWidget() {
    console.log('Showing Kustomer chat for DTC mode');

    if (window.Kustomer && kustomerInitialized) {
      // Show Kustomer widget if already loaded
      var kustomerIframe = document.querySelector('iframe[title*="Kustomer"]');
      if (kustomerIframe) {
        kustomerIframe.style.display = '';
      }
      // Show the button
      var kustomerButton = document.querySelector('[data-kustomer-widget-button]');
      if (kustomerButton) {
        kustomerButton.style.display = '';
      }
    }
  }

  function setupScrollListener() {
    // Don't set up if already active
    if (scrollListenerActive) return;

    console.log('Setting up Kustomer chat scroll listener for DTC mode');

    scrollHandler = function() {
      if (!scrollListenerActive) return; // Guard against race conditions

      loadKustomerWidget();
      window.removeEventListener('scroll', scrollHandler);
      scrollListenerActive = false;
    };

    window.addEventListener('scroll', scrollHandler, { once: true });
    scrollListenerActive = true;
  }

  function checkAndUpdateChat() {
    const userExperience = document.body.getAttribute('data-user-experience');

    if (userExperience === 'dtc') {
      if (kustomerInitialized) {
        showKustomerWidget();
      } else {
        setupScrollListener();
      }
    } else if (userExperience === 'b2b') {
      hideKustomerChat();
    }
  }

  // Check initial state on page load
  if (document.readyState === 'loading') {
    document.addEventListener('DOMContentLoaded', checkAndUpdateChat);
  } else {
    checkAndUpdateChat();
  }

  // Listen for toggle button clicks
  document.addEventListener('click', function(event) {
    const toggleElement = event.target.closest('.toggle-header-title-bar-container__toggle-dtc-element');
    if (toggleElement) {
      // Wait a bit for the attribute to update
      setTimeout(checkAndUpdateChat, 100);
    }
  });

  // Watch for body attribute changes (fallback)
  if (typeof MutationObserver !== 'undefined') {
    const observer = new MutationObserver(function(mutations) {
      mutations.forEach(function(mutation) {
        if (mutation.type === 'attributes' && mutation.attributeName === 'data-user-experience') {
          checkAndUpdateChat();
        }
      });
    });

    observer.observe(document.body, {
      attributes: true,
      attributeFilter: ['data-user-experience']
    });
  }
})();
